import { render, staticRenderFns } from "./orderDetailJoin.vue?vue&type=template&id=baccc07e&scoped=true&"
import script from "./orderDetailJoin.vue?vue&type=script&lang=js&"
export * from "./orderDetailJoin.vue?vue&type=script&lang=js&"
import style0 from "./orderDetailJoin.vue?vue&type=style&index=0&id=baccc07e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baccc07e",
  null
  
)

export default component.exports